'use client';

import React from 'react';
import { useFloatingChat } from './FloatingChatContext';
import { FloatingChatBox } from './FloatingChatBox';

export function FloatingChatDock() {
  const { dockedChats, closeChat, toggleMinimize } = useFloatingChat();

  if (!dockedChats || dockedChats.length === 0) {
    return null;
  }

  return (
    <div
      aria-label="Floating Chat Dock"
      className="fixed bottom-0 right-4 z-50 flex items-end gap-3 pointer-events-none max-w-[calc(100vw-2rem)] overflow-x-auto pb-0"
    >
      {dockedChats.map((chat) => (
        <FloatingChatBox
          key={chat.id || chat.remoteJid}
          chat={chat}
          onClose={() => closeChat(chat.id, chat.remoteJid)}
          onToggleMinimize={() => toggleMinimize(chat.id, chat.remoteJid)}
        />
      ))}
    </div>
  );
}
